import React from 'react';
import { KitFormInfoText, KitFormLabel } from './KitFormControls';
import KitTextArea, { KitTextAreaProps } from './KitTextArea';

export interface KitFormTextAreaProps extends KitTextAreaProps {
  id: string;
  label?: string;
  labelAs?: 'label' | 'h4';
  required?: boolean;
}

export const KitFormTextArea = React.forwardRef<HTMLTextAreaElement, KitFormTextAreaProps>(
  ({ id, label, labelAs, required, infoMessage, ...rest }, ref) => {
    const infoTextId = `${id}Info`;
    return (
      <>
        {label && <KitFormLabel required={required} text={label} htmlFor={id} as={labelAs} />}
        <KitTextArea
          id={id}
          name={id}
          data-qa-id={id}
          aria-describedby={infoMessage ? infoTextId : undefined}
          ref={ref}
          {...rest}
        />
        {infoMessage && (
          <KitFormInfoText
            text={infoMessage}
            isError={rest.isError}
            id={infoTextId}
            data-qa-id={infoTextId}
            aria-live='polite'
          />
        )}
      </>
    );
  }
);
